<template>
    <v-container fluid grid-list-md>
        <garage-locations></garage-locations>
    </v-container>
</template>
<script>
import GarageLocations from '../components/GarageLocations/List.vue';

export default {
    components: {
        GarageLocations
    }
};
</script>
